<div class="inheritance-info">
	@if (isInherited) {
		<a
			[matTooltip]="parentValueText"
			matTooltipPosition="right"
			matTooltipHideDelay="250"
			matTooltipClass="info-tooltip"
			[ngClass]="{ 'hierarchy-icon': true, active: _disabled === false, 'hierarchy-icon-disabled': _disabled === true }">
			<span class="fa-stack fa-1x">
				<fa-icon
					[icon]="faSitemap"
					class="fas fa-stack-1x"
					[ngClass]="{ 'hierarchy-icon': true, active: _disabled === false, 'hierarchy-icon-disabled': _disabled === true }"></fa-icon>
			</span>
		</a>
	} @else {
		<a
			[matTooltip]="parentValueText"
			matTooltipPosition="right"
			matTooltipHideDelay="250"
			matTooltipClass="info-tooltip"
			[ngClass]="{ 'hierarchy-icon': true, active: _disabled === false, 'hierarchy-icon-disabled': _disabled === true }">
			<span class="fa-stack fa-1x">
				<fa-icon
					[icon]="faSitemap"
					class="fas fa-stack-1x"
					[ngClass]="{ 'hierarchy-icon': true, active: _disabled === false, 'hierarchy-icon-disabled': _disabled === true }"></fa-icon>
				<fa-icon
					[icon]="faSlash"
					class="fab fa-stack-1x fa-inverse"
					[ngClass]="{ 'hierarchy-icon': true, active: _disabled === false, 'hierarchy-icon-disabled': _disabled === true }"></fa-icon>
			</span>
		</a>
	}
</div>
